export default __webpack_public_path__ + "static/media/hexowatch-logo-rectangle-white.eaa0d3c9.svg";